import { Component, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnalysisExportStatus } from '@api-types/enums/analysis-export-status.enum';
import { DateUtilsService } from '@core/utils/date-utils.service';
import { FormInputCheckboxComponent, PmIconComponent } from '@libs/ui';
import { LucideCircleX, LucideLoaderCircle } from '@lucide/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AnalysisStateService } from 'demand-forecasting/analysis/services/analysis-state.service';

@Component({
  selector: 'pm-export-list-tab',
  templateUrl: './export-list-tab.component.html',
  imports: [
    TranslateModule,
    MatProgressSpinnerModule,
    FormsModule,
    FormInputCheckboxComponent,
    PmIconComponent,
  ],
})
export class ExportListTabComponent {
  protected readonly analysisStateService = inject(AnalysisStateService);
  protected readonly AnalysisExportStatus = AnalysisExportStatus;
  protected readonly dateUtilsService = inject(DateUtilsService);

  protected readonly loaderIcon = LucideLoaderCircle;
  protected readonly errorIcon = LucideCircleX;

  selectedExportId = model<string | undefined>();
}
